export default {
    inquiryAndAttendance: 'Inquiry & Attendance',
    inquiryAndAttendanceSub: 'Note: Attendance images will be removed after 3 months',
    inquiry: 'Inquiry',
    searchByEmployeeName: 'Search by Employee Name',
    search: 'Search',
    allStatus: 'All Status',
    pending: 'Pending',
    approve: 'Approve',
    reject: 'Reject',
    employeeName: 'Employee Name',
    group: 'Group',
    department: 'Department',
    type: 'Type',
    inquiryDate: 'Inquiry Date',
    period: 'Period',
    fullDay: 'Full Day',
    halfDay: 'Half Day',
    status: 'Status',
    cannotEditTheApproval: 'Cannot edit the approval inquiry',
    cannotEditTheRejected: 'Cannot edit the rejected inquiry',
    statusAttendance: 'Status Attendance',
    manageAttendance: 'Manage Attendance',
    manageAttendanceRequest: 'Manage Attendance Request',
    overtimeRequest: 'Overtime Request',
    punchLog: 'Punch Log',
    checkInLocation: 'Check-In Location',
    forgotCheckInReq: 'Forgot Check In Request'
}
